var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image.circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M8.5 15.5a7 7 0 100-14 7 7 0 000 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 12l3.797-3.797a1.002 1.002 0 011.406 0L9.5 12l1.79-1.79a1.008 1.008 0 011.418-.002L15.5 13v3.15H.5V12z",
    id: "Path-2",
    stroke: "#000",
    fillOpacity: 0.35,
    fill: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000",
    mask: "url(#mask-2)",
    cx: 10,
    cy: 6,
    r: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFill);
export default __webpack_public_path__ + "static/media/image-fill.255c38ec.svg";
export { ForwardRef as ReactComponent };